import React from 'react';
import AuthStore from 'stores/AuthStore';
import TeamListStore from 'stores/TeamListStore';
import TeamActions from 'actions/TeamActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import {UserContextType} from 'components/triggers/UserContextType';

class UserInTeamConditionComponent extends React.Component {
  static getStores() {
    return [TeamListStore];
  }

  static getPropsFromStores(nextProps) {
    const {context, contextType} = nextProps;
    const team = TeamListStore.getState().teams.find(d => d && d.id === context.team_id);
    return {team, contextType};
  }

  componentDidMount() {
    // Check to see if the team list has been loaded.
    const {context} = this.props;
    const isAdmin = AuthStore.getState().user.isAdmin();
    const team = TeamListStore.getState().teams.find(d => d && d.id === context.team_id);
    if (!team) {
      TeamActions.fetchAllTeams.defer(isAdmin);
    }
  }

  render() {
    const {team, contextType} = this.props;
    if (!team) {
      return null;
    }
    return (
      <div>
        {contextType === UserContextType.USER && (
          <span>
            a member of team{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              {team.name}
            </span>{' '}
            reviews a call
          </span>
        )}
        {contextType === UserContextType.CALLER && (
          <span>
            is placed or received by a member of team{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              {team.name}
            </span>
          </span>
        )}
        {contextType === UserContextType.CALL && (
          <span>
            the call is placed or received by a member of team{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              {team.name}
            </span>
          </span>
        )}
      </div>
    );
  }
}

export default connectToStores(UserInTeamConditionComponent);
